export default function editQuiz(quizObj = {}, action) {
  if (action.type === 'editQuiz') {
    return action.quizObj;
  } else {
    return quizObj;
  }
}
